export const QB_66_EXPECTED_CHAL_RECIPES = ['chal-1', 'chal-2', 'chal-3', 'chal-4', 'chal-5', 'chal-6'];
/**
 * TEMPORARY: For QuoteBot Accelerator; See QB-66.
 */
export const QB_66_LINK_OVERRIDES_BY_CHAL_RECIPE = {
  'chal-1': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'AI Shopping Assistant',
      'link-url': 'https://ai.coracar.com/',
      newTab: true,
    },
  },
  'chal-2': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'AI Shopping with Cora',
      'link-url': 'https://ai.coracar.com/',
      newTab: true,
    },
  },
  'chal-3': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'AI Price Negotiator',
      'link-url': 'https://ai.coracar.com/',
      newTab: true,
    },
  },
  'chal-4': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'Price Negotiation Assistant',
      'link-url': 'https://confidence.coracar.com/',
      newTab: true,
    },
  },
  'chal-5': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'Local Deal Finder',
      'link-url': 'https://savings.coracar.com/',
      newTab: true,
    },
  },
  'chal-6': {
    targetCtrlUrl: '/price-checker/',
    override: {
      title: 'Find Local Deals with Cora',
      'link-url': 'https://savings.coracar.com/',
      newTab: true,
    },
  },
};
